import React, { createContext, useContext } from 'react';
import { COLORS, TYPOGRAPHY, SPACING, SHADOWS, BORDER_RADIUS, TRANSITIONS } from '../theme/tokens';
interface ThemeContextType {
  colors: typeof COLORS;
  typography: typeof TYPOGRAPHY;
  spacing: typeof SPACING;
  shadows: typeof SHADOWS;
  borderRadius: typeof BORDER_RADIUS;
  transitions: typeof TRANSITIONS;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const theme: ThemeContextType = {
    colors: COLORS,
    typography: TYPOGRAPHY,
    spacing: SPACING,
    shadows: SHADOWS,
    borderRadius: BORDER_RADIUS,
    transitions: TRANSITIONS
  };
  return <ThemeContext.Provider value={theme} data-id="element-492">{children}</ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}